// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e506b753","498":"dec330a0","703":"d45c78c4"}[chunkId] + ".chunk.js";
};